import * as React from 'react';

import { cn } from '@/lib/utils';

// Themed multi-line field — the textarea counterpart to TextInput. Uses the
// same --color-* token family and focus-ring idiom so multi-line fields match
// the single-line inputs and Radix selects rather than rendering as raw
// white <textarea>s on themed surfaces. Drop-in for native <textarea>:
// forwards every native prop (value, onChange, rows, placeholder, ref, …).
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, style, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        // 16px on phones — see text-input.tsx: sub-16px fonts trigger
        // iOS Safari's focus zoom.
        'w-full min-h-[80px] px-3 py-2 rounded-lg border text-base sm:text-sm transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-500)] focus:border-transparent',
        'placeholder:text-[var(--color-text-tertiary)] disabled:opacity-60 disabled:cursor-not-allowed',
        className,
      )}
      style={{
        borderColor: 'var(--color-border-primary)',
        backgroundColor: 'var(--color-bg-primary)',
        color: 'var(--color-text-primary)',
        ...style,
      }}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';

export { Textarea };
